<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h4 class="mb-0">
      <i class="bi bi-gear text-warning me-2"></i>{{ 'admin.settings.title' | translate }}
    </h4>
    <button class="btn btn-accent" *ngIf="activeTab === 1" (click)="addVehicleType()">
      <i class="bi bi-plus me-2"></i>{{ 'admin.settings.new_vehicle_type' | translate }}
    </button>
  </div>

  <div class="card">
    <div class="card-body">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (activeIdChange)="onTabChange()" class="nav-tabs">
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <i class="bi bi-car-front me-2"></i>{{ 'admin.settings.tab_vehicle_types' | translate }}
          </a>
          <ng-template ngbNavContent>
            <s-table [cols]="tabVehicleTypes.cols" [refreshUrl]="tabVehicleTypes.refreshUrl"
              [detailUrl]="tabVehicleTypes.detailUrl" [detailId]="tabVehicleTypes.detailId"
              [showPageSize]="!shared.isMobileConst">
            </s-table>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>
  </div>
</div>
